import { createCalendarViewContainer } from 'factories/CalendarView'
import selectors from 'selectors'
import actions from 'actions/orders'
import Component from 'components/Orders/CalendarView'

export default createCalendarViewContainer({ actions, selectors: selectors.orders })(Component)
